export const techOptions = [
  { label: "ColorJet Printing", value: "CJP" },
  { label: "Direct Light Processing", value: "DLP" },
  { label: "Direct Metal Printing", value: "DMP" },
  { label: "Extrusion", value: "Extrusion" },
  { label: "MultiJet Printing", value: "MJP" },
  { label: "Selective Laser Sintering", value: "SLS" },
  { label: "Stereolithography", value: "SLA" },
];
